module.exports = __webpack_public_path__ + "img/7d30ade.png";